import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { EventStatusFetchParams } from './EventStatus.type';

let listRequest: any = null;

const EventStatusService = {
  getList: (
    eventId: number[] | string[] | number | string | undefined,
    params: EventStatusFetchParams,
  ) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    //TODO: rewrite endpoint
    const url = eventId ? `events/${eventId}/status/all` : `events/status/all`;
    return axios.get(getEndpointBase(url), {
      cancelToken: listRequest.token,
      params: {
        ...params,
      },
    });
  },
};

export default EventStatusService;
